import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import pageMinx from "./mixins/pageMinx";
import { tabulation } from "@/mixins/index";
import { allRecharge, allRecharge_currency } from "@/api/index/index";
export default {
  mixins: [tabulation, pageMinx],
  data: function data() {
    return {
      // finallyFn: ['getallRecharge'],
      reqFn: 'getallRecharge',
      allRechargeData: [],
      isSpecial: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'user.isSpecial',
                user: true
              }, {
                root: true
              });

            case 2:
              _this.isSpecial = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  methods: {
    // 项目汇总
    getallRecharge: function getallRecharge() {
      var _this2 = this;

      var isverification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.isSpecial || !this.rawData.game_mark) {
        return;
      } // if(this.currencyClose && !this.searchData.currency_info){
      //   if(isverification){
      //     this.$message.error('请选择货币类型')
      //   }
      //   return
      // }


      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(replace) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this2.reqLoading = true;
                  reqFn = _this2.currencyClose ? allRecharge_currency : allRecharge;
                  _context2.next = 4;
                  return _this2.getexchangeRate();

                case 4:
                  reqFn(_objectSpread(_objectSpread({}, _this2.searchData), _this2.defaultData())).then(function (res) {
                    if (res.code == 200) {
                      res.data.recharge_amountexchange = _this2.isyjfmvnd() ? (Number(res.data.recharge_amount) * _this2.exchangeRate).toFixed(2) : _this2.$utils.conversion(Number(res.data.recharge_amount) * _this2.exchangeRate).toFixed(2);
                      res.data.recharge_amount = _this2.isyjfmvnd() ? res.data.recharge_amount.toFixed(2) : _this2.$utils.conversion(res.data.recharge_amount).toFixed(2);
                      _this2.allRechargeData = [res.data];
                    }
                  }).finally(function () {
                    _this2.reqLoading = false;
                    replace();
                  });

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    resettingData: function resettingData() {
      this.allRechargeData = [];
    }
  }
};